var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('naj-button',{staticClass:"back-btn",attrs:{"to":"/","size":"small","square":""}},[_vm._v(" "+_vm._s(_vm.local.common.backToHome)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }